var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfile = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12.342,
  cy: 6.76316,
  r: 2.96316,
  strokeWidth: 1.6
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.5 17.5966C5.5 14.8255 7.74643 12.5791 10.5175 12.5791H13.4825C16.2536 12.5791 18.5 14.8255 18.5 17.5966V17.5966C18.5 18.9822 17.3768 20.1054 15.9912 20.1054H8.00877C6.62322 20.1054 5.5 18.9822 5.5 17.5966V17.5966Z",
  strokeWidth: 1.6
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfile);
export default ForwardRef;